import React from 'react';
import Bodenfeuchte from '../components/Bodenfeuchte';
import './home.css'; // gleiche Styles wie bei Home verwenden

function BodenfeuchteMatzen() {
  return (
    <div
      className="home-container"
      role="main"
      aria-labelledby="bodenfeuchte-matzen-heading"
    >
      <div className="home-diagramm">
        <div className="wetter-container">
          <h1 id="bodenfeuchte-matzen-heading">BODENFEUCHTE</h1>
        </div>

        <Bodenfeuchte ort="matzen" />
      </div>
    </div>
  );
}

export default BodenfeuchteMatzen;
